module.exports = __webpack_public_path__ + "static/img/weixuanzhongshiping.png@2x.da6d20b7.png";